import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import WhyChoose from "@/components/WhyChoose";
import PracticeAreas from "@/components/PracticeAreas";
import Experience from "@/components/Experience";
import Values from "@/components/Values";
import LegalInsights from "@/components/LegalInsights";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyMobileBar from "@/components/StickyMobileBar";
import DisclaimerModal from "@/components/DisclaimerModal";

export default function Home() {
  useEffect(() => {
    document.title = "Harshavardhan Prakash Patil | Advocate | Bombay High Court | Kolhapur Bench";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = "Professional legal representation before the Bombay High Court and Kolhapur Bench in Criminal, Civil, Writ and Service Matters.";
  }, []);

  return (
    <div className="relative">
      <DisclaimerModal />
      <Nav />
      <Hero />
      <EditorialMarquee />
      <About />
      <WhyChoose />
      <PracticeAreas />
      <Experience />
      <Values />
      <LegalInsights />
      <Contact />
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
